import { cloneDeep } from 'lodash';
import Vue from 'vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';

export default {
    data() {
        return {
            formEditable: false,
            isFormDirty: false,
            isFormValid: true,
            updatedData: {},
        };
    },
    computed: {
        defaultData() {
            return {};
        },
    },
    created() {
        this.initFormData();
    },
    methods: {
        initFormData() {
            this.updatedData = cloneDeep(this.defaultData);
        },
        updateData(data) {
            this.updatedData = data;
        },
        onClickToggle() {
            if (this.isFormDirty && this.formEditable) {
                this.$root.$emit('showModal', {
                    title: this.$t('forms.labels.confirmUnsavedChangesTitle'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: this.$t('msg.confirmUnsavedChanges') },
                    onConfirm: this.cancelModifications.bind(this),
                    isForm: false,
                });
            } else {
                this.formEditable = !this.formEditable;
                this.updatedData.initialStatus = this.formEditable;
            }
        },
        cancelModifications() {
            const { observer } = this.$refs?.mainForm?.$refs;

            this.initFormData();
            this.formEditable = false;

            observer.reset();
            observer.validate();
        },
    },
};
